module.exports = __webpack_public_path__ + "img/10.7b7775d2.png";